var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjects = function SvgProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 63,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m25.67 40.642 11.45-1.685m.652-11.809-3.39-3.741 2.44-3.963a5.786 5.786 0 0 0-7.16-8.416l-5.056 1.809-3.875-3.975a5.787 5.787 0 0 0-10.062 3.669l.395 5.548-4.758 1.946a5.787 5.787 0 0 0 1.038 10.832l1.994.496"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m49.239 25.46 4.203-16.353a2.89 2.89 0 0 0-2.15-3.539l-10.81-2.494a2.893 2.893 0 0 0-3.443 2.065l-1.75 6.464M7.235 34.597a2.893 2.893 0 0 1 2.421-3.299l40.094-5.9a2.893 2.893 0 0 1 3.284 2.442l2.948 20.038a5.787 5.787 0 0 1-4.883 6.567L16.75 59.5a5.787 5.787 0 0 1-6.568-4.882z"
  })));
};
export default SvgProjects;